<template>
    <div>
        <veui-dialog
            theme="ai"
            :open="open"
            overlay-class="pay-dialog"
            title="点券充值"
            @cancel="handleClose"
            @ok="handleClose"
        >
            <div class="pay-dialog-content">
                <div class="pay-subtitle">支持多充多送，以更低的价格支付各项能力</div>

                <div class="pay-card-container">
                    <coupon-pay-card
                        v-for="item in productList"
                        :key="item.id"
                        :data="item"
                        :selected="selected === item.id"
                        @check="handleClickCard"
                    />
                </div>
                <div class="pay-tip">
                    <div class="pay-tip-title">
                        权益说明
                    </div>
                    <div
                        v-for="(item,index) in couponPayTips"
                        :key="index"
                        class="tip-item"
                    >
                        <span class="tip-item-order">{{ item.order }}</span>
                        <span>{{ item.text }}</span>
                        <template v-if="item.children">
                            <div
                                v-for="(v,i) in item.children "
                                :key="`${index}-${i}}`"
                                class="tip-item"
                                style="margin-left: 12px;"
                            >
                                <span class="tip-item-order">{{ v.order }}</span>
                                <span>{{ v.text }}</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <template #foot>
                <div class="pay-dialog-footer">
                    <div class="pay-dialog-footer-left">
                        <veui-checkbox v-model="checkDoc" theme="ai"/>
                        <span>
                            <span>我已阅读并同意</span>
                            <veui-button
                                theme="ai" ui="text strong"
                                @click="handleClickDoc('platformProtocol')"
                            >
                                《擎舵平台用户服务协议》
                            </veui-button>
                            <veui-button
                                theme="ai" ui="text strong"
                                @click="handleClickDoc('aiPurchaseProtocol')"
                            >
                                《擎舵平台生成服务协议》
                            </veui-button>
                        </span>
                    </div>
                    <div class="pay-dialog-footer-right">
                        <div
                            class="pay-btn"
                            @click="handlePay"
                        >
                            立即支付
                        </div>
                    </div>
                </div>
            </template>
        </veui-dialog>
        <cc-pay-dialog
            v-if="showPayConfirmDialog"
            :open.sync="showPayConfirmDialog"
            @cancel="handleCloseConfirm"
            @finish="handleCloseConfirm"
            @retry="handlePayRetry"
        />
    </div>
</template>

<script>
import {Dialog, Button, Checkbox} from 'veui';
import {platformProtocolPath} from '@/config/default';
import CouponPayCard from './CouponPayCard.vue';
import PayDialog from '@/views/Order/components/PayDialog';
import couponMixin from '@/mixins/couponMixin';
import {productMap, couponPayTips} from '@/common/couponConfig';
export default {
    name: 'CouponPayDialog',
    inject: ['$toast', 'model', 'alsLog'],
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-checkbox': Checkbox,
        'coupon-pay-card': CouponPayCard,
        'cc-pay-dialog': PayDialog
    },
    mixins: [couponMixin],
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checkDoc: false,
            productList: [],
            selected: undefined, // 选中的商品id
            showPayConfirmDialog: false,
            couponPayTips,
            payUrl: ''
        };
    },
    watch: {
        open(val) {
            if (val) {
                this.checkDoc = false;
                this.getProductList();
            }
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:open', false);
        },
        async handlePay() {
            if (!this.selected) {
                this.$toast.warn('请选择商品');
                return;
            }
            if (this.checkDoc === false) {
                this.$toast.warn('请阅读并同意《擎舵平台用户服务协议》《擎舵平台生成服务协议》');
                return;
            }
            this.alsLog({
                f1: 'couponPayDialog',
                f2: 'submit',
                f11: this.selected
            });
            const params = {
                productId: this.selected,
                productNums: 1
            };
            try {
                const data = await this.model.coupon.payOrder(params);
                this.payUrl = data;
                window.open(data);
                // 关闭充值弹窗
                this.$emit('update:open', false);
                // 当前页加弹窗进行支付完成的确认
                this.showPayConfirmDialog = true;
            }
            catch (err) {
                this.$toast.error(err.message);
            }
        },
        // 支付完成或者取消，都是关闭弹窗、刷新列表
        handleCloseConfirm() {
            this.showPayConfirmDialog = false;
            // 重新获取点券余额
            this.getCouponInfo();
        },
        // 重新支付
        async handlePayRetry() {
            window.open(this.payUrl);
        },
        handleClickCard(item) {
            this.selected = item.id;
        },
        handleClickDoc(type) {
            this.alsLog({
                f1: 'couponPayDialogProtocol',
                f2: 'click',
                f11: type
            });
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            let docPath = '';
            switch (type) {
                case 'platformProtocol':
                    docPath = platformProtocolPath;
                    break;
                case 'aiPurchaseProtocol':
                    docPath = '/userCenter/aboutUs?active=aiPurchaseProtocol';
                    break;
                default:
                    docPath = platformProtocolPath;
            }
            const url = `${prefix}${docPath}`;
            window.open(url, '_blank', 'noreferrer');
        },
        async getProductList() {
            const params = {
                'spuTypeEnum': 'COUPON_PACKAGE' // 点券加油包 不传就是代表所有的商品查询
            };
            const res = await this.model.coupon.getProductList(params);
            const list = res.items || [];
            this.productList = list.map(i => {
                const {id, skuName, ...rest} = i;
                const desc = productMap[id]?.desc?.split('-')?.[1];
                return {
                    ...rest,
                    id,
                    skuName: desc || skuName
                };
            });
            this.selected = this.productList[0].id;
        }
    },
    computed: {

    },
    mounted() {

    }
};
</script>

<style scoped lang="less">
.pay-dialog {
    /deep/ .veui-ai-dialog-content {
        width: 832px;
        height: 580px;
        border-radius: 16px;
        background-image: url('../../assets/couponPayBg.png');
        background-repeat: no-repeat;
        background-size: 880px 160px;
        background-position: right top;
        &-body {
            padding: 0 24px;
        }
    }
    /deep/ .veui-ai-dialog-content-head-close {
        font-size: 20px;
    }
    /deep/ .veui-ai-dialog-content-head-title {
        color: var(----G9, #191B1E);
        font-size: 20px;
        font-weight: 600;
        line-height: 28px; /* 140% */
    }
    .pay-subtitle {
        margin: 4px 0 16px 0;
        line-height: 28px;
    }
    .pay-tip {
        margin-top: 24px;
        color: var(----hover-G8, #545B66);
        line-height: 26px; /* 185.714% */
        &-title {
            color: var(----G9, #191B1E);
            font-weight: 600;
            line-height: 20px; /* 142.857% */
            margin-bottom: 8px;
        }
    }
    .pay-card-container {
        display: flex;
        gap: 16px;
    }
    .pay-dialog-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pay-dialog-footer-left {
            display: flex;
            align-items: center;
            gap: 4px;
            color: var(----hover-G8, #545B66);
        }
        /deep/ .veui-ai-button {
            margin: 0;
        }
        .pay-btn {
            width: 200px;
            height: 48px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 4px;
            border-radius: var(--Radius-r4, 26px);
            border: 1px solid #FFFBF1;
            background: linear-gradient(92deg, #ECCD74 0%, #FDE6BA 51.23%, #E9AF46 100%);
            box-shadow: 0px 1px 4px 0px rgba(255, 255, 255, 0.60) inset;
            color: var(--Yellow-10, #664300);
            /* T2 小标题/medium */
            font-family: "PingFang SC";
            font-size: 16px;
            font-weight: 500;
            line-height: 22px; /* 137.5% */
        }
    }
    .tip-item {
        &-order {
            display: inline-block;
            width: 12px;
            line-height: 20px;
            margin-right: 6px;
        }
    }
}
</style>